import { Icon } from "@chakra-ui/react";
import React from "react";

/**
 * Renders the logo icon
 * 
 * @param {Object} props - The props of the component
 * @returns The logo icon
 */
const LogoIcon = (props) => (
  <Icon viewBox="0 0 500 500" {...props}>
    <path className="st0" d="M419.5,37.8H79.8c-30.4,0-54.9,25.3-54.9,55.7v251.6c0,30.4,24.6,54.9,54.9,54.9h290.6l60,55.7c5.1,4.3,11.6,6.5,18.1,6.5s7.2-.7,10.8-2.2c9.4-4.3,15.9-13.7,15.9-24.6V93.5c0-30.4-24.6-55.7-55.7-55.7h0ZM450.6,435.4c0,.7,0,1.5-1.5,2.2-.7,0-1.5-.7-1.5-.7l-67.9-61.4H79.7c-16.6,0-30.4-13.7-30.4-30.4V93.5c0-16.6,13.7-30.4,30.4-30.4h339.7c17.3,0,31.1,13.7,31.1,30.4v341.9h0Z" fill="currentColor" />
    <polygon className="st0" points="197.6 216.4 259 300.2 219.3 300.2 177.3 243.1 136.1 300.2 95.7 300.2 157.1 217.1 99.3 137.6 139 137.6 178.1 191.1 216.4 137.6 255.4 137.6 197.6 216.4 197.6 216.4" fill="currentColor" />
    <path className="st0" d="M365.3,246.7c18.8-10.1,29.6-27.5,29.6-50.6,0-36.1-26-58.6-68.7-58.6h-65.1v162.6h34v-45.5h37.6l31.8,45.5h39l-38.3-53.5h0ZM295.2,168.7h30.4c23.9,0,35.4,9.4,35.4,27.5s-11.6,28.2-35.4,28.2h-30.4v-55.7h0Z" fill="currentColor" />
  </Icon>
);

export default React.memo(LogoIcon);
